"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[EventBufferConfiguration]] contains necessary information to
 * configure buffer.
 */
var EventBufferConfiguration = function EventBufferConfiguration() {
  var flushIntervalMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
  var flushSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var maxBufferCapacityKb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 64;
  var totalBufferItems = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
  var retryCountLimit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 15;
  _classCallCheck(this, EventBufferConfiguration);
  this.flushIntervalMs = flushIntervalMs;
  this.flushSize = flushSize;
  this.maxBufferCapacityKb = maxBufferCapacityKb;
  this.totalBufferItems = totalBufferItems;
  this.retryCountLimit = retryCountLimit;
};
exports.default = EventBufferConfiguration;